// Reducer for the table state (paging, search, sort) and loading state of the unassigned tasks
// page. Same table actions as pendingTaskReducer; this page has no dialogs.
export const initialState = {
	loading: {
		// Full-page backdrop while a claim runs.
		isLoadingBackdrop: false,
	},
	table: {
		currentPage: 1,
		// Empty = the backend default (most recently modified first).
		sortField: "",
		sortDirection: "",
		// True when the sorted column is sorted by its translated label (column config sortByLabel).
		sortByLabel: false,
		searchInput: "",
		startDateInput: "",
		endDateInput: "",
		searchParams: {
			searchTerm: "",
			startDate: "",
			endDate: "",
		},
		recordsPerPage: 10,
	},
};

// Every action that changes which rows match (search, sort, page size) also goes back to page 1,
// here in one place, so no handler has to remember to do it.
export function unassignedTaskReducer(state, action) {
	switch (action.type) {
		case "SET_PAGE":
			return { ...state, table: { ...state.table, currentPage: action.payload } };
		case "SET_RECORDS_PER_PAGE":
			return { ...state, table: { ...state.table, recordsPerPage: action.payload, currentPage: 1 } };
		case "SET_SORT":
			return {
				...state,
				table: {
					...state.table,
					sortField: action.payload.field,
					sortDirection: action.payload.direction,
					sortByLabel: action.payload.byLabel === true,
					currentPage: 1,
				},
			};
		case "SET_SEARCH_INPUT":
			return { ...state, table: { ...state.table, searchInput: action.payload } };
		case "SET_START_DATE_INPUT":
			return { ...state, table: { ...state.table, startDateInput: action.payload } };
		case "SET_END_DATE_INPUT":
			return { ...state, table: { ...state.table, endDateInput: action.payload } };
		case "SET_SEARCH_PARAMS":
			return { ...state, table: { ...state.table, searchParams: action.payload, currentPage: 1 } };
		case "CLEAR_FILTERS":
			return {
				...state,
				table: {
					...state.table,
					searchInput: initialState.table.searchInput,
					startDateInput: initialState.table.startDateInput,
					endDateInput: initialState.table.endDateInput,
					searchParams: initialState.table.searchParams,
					sortField: initialState.table.sortField,
					sortDirection: initialState.table.sortDirection,
					sortByLabel: initialState.table.sortByLabel,
					currentPage: 1,
				},
			};
		case "SET_LOADING":
			return { ...state, loading: { ...state.loading, [action.payload.key]: action.payload.value } };
		default:
			return state;
	}
}
